export default __webpack_public_path__ + "static/media/Rola-Omoda---Banner-1.d3fb5072.webp";